<template>
  <div role="main" class="container-fluid">
    <Crosswalk />
    <AppDescription />
    <TeamUp />
    <MobileApp />
    <Map />
  </div>
</template>

<script>
import Crosswalk from "@/components/Crosswalk";
import AppDescription from "@/components/AppDescription";
import TeamUp from "@/components/TeamUp";
import MobileApp from "@/components/MobileApp";
import Map from "@/components/MapLayout";

export default {
  components: {
    Crosswalk,
    TeamUp,
    AppDescription,
    MobileApp,
    Map
  }
};
</script>

<style scoped>
.container-fluid {
  padding-right: 0;
  padding-left: 0;
}
</style>
